import { useState } from 'react';
import { NetworkStatus } from '@apollo/client';
import type { ProductCatalogBrandsListQuery } from './getAllBrands.graphql.generated';
import type { ProductCatalogBrandsDirectoryQueryInput } from '@graphql/generated-base';
import { useProductCatalogBrandsListQuery } from './getAllBrands.graphql.generated';

export type BrandListType = ProductCatalogBrandsListQuery['productCatalogBrandsDirectory']['brands'];

type BrandListData = ProductCatalogBrandsListQuery['productCatalogBrandsDirectory'];

export const useGetAllBrands = (args: ProductCatalogBrandsDirectoryQueryInput) => {
  const [brandListData, setBrandListData] = useState<BrandListData>({ brands: [], categories: [] });

  const { error, networkStatus } = useProductCatalogBrandsListQuery({
    variables: { args },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    onCompleted: data => {
      setBrandListData(data?.productCatalogBrandsDirectory);
    },
  });

  return {
    brandList: brandListData?.brands,
    categories: brandListData?.categories,
    loading: networkStatus === NetworkStatus.loading,
    error,
  };
};
